import { Map as IMap } from 'immutable';



export const getAuthState = state => state.get('auth') || IMap();

export const getAuthStatus = state => getAuthState(state).get('status') || 'idle';

export const getIsAuthenticated = state => getAuthStatus(state) === 'authenticated';



export const getSsoSid = state => getAuthState(state).get('ssoSid') || null;



export const getSessionExpired = state => getAuthState(state).get('sessionExpired') === true;

export const getIdentity = (state) => {
    const identity = getAuthState(state).get('identity');
    return identity ? identity.toJS() : null;
};

export const getFirstName = (state) => {
    const identity = getAuthState(state).get('identity');
    if (!identity) return null;
    return identity.get('firstName') || identity.get('fullName') || null;
};

export const getFullName = (state) => {
    const identity = getAuthState(state).get('identity');
    if (!identity) return null;
    return identity.get('fullName') || identity.get('firstName') || null;
};

export const getLoyaltyNumber = (state) => {
    const identity = getAuthState(state).get('identity');
    if (!identity) return null;
    return identity.get('loyalty') || null;
};

export const getEmail = (state) => {
    const identity = getAuthState(state).get('identity');
    if (!identity) return null;
    return identity.get('email') || null;
};
